import { Segmented } from "antd";
import { IconPack } from "Explore/Config/Icons";
import styles from "./TabListSelect.module.scss";
import { Tab, Tabs } from "@mui/material";

export const TAB_OPTION_VALUES = {
  LIST: 0,
  GRAPH: 1,
};

export const TAB_LIST_OPTIONS = [
  {
    label: (
      <>
        {IconPack.list}
        <div>List view</div>
      </>
    ),
    value: TAB_OPTION_VALUES.LIST,
  },
  {
    label: (
      <>
        {IconPack.graph}
        <div>Graph view</div>
      </>
    ),
    value: TAB_OPTION_VALUES.GRAPH,
  },
];

const TabListSelect = ({ currentOption, setOption, options }) => {
  return (
    <Tabs
      value={currentOption}
      onChange={(_, value) => setOption(value)}
      classes={{
        root: styles["tab-list-segmented"],
        indicator: styles["tab-list-indicator"],
      }}
    >
      {(options || TAB_LIST_OPTIONS).map((option) => (
        <Tab
          key={option.value}
          value={option.value}
          label={option.label}
          classes={{
            root: styles["tab-list-tab"],
            selected: styles["tab-list-selected"],
          }}
        />
      ))}
    </Tabs>
  );
};

export default TabListSelect;
